var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fit" },
    [
      _c("Grid", {
        attrs: {
          id: "certificatesListGrid",
          module: _vm.module,
          data: _vm.orders,
          "rows-per-page-options": [0],
          columns: _vm.columnOptions,
          onLaunch: _vm.one
        },
        scopedSlots: _vm._u([
          {
            key: "col-item-status",
            fn: function(props) {
              return [
                _c(
                  "div",
                  {
                    staticClass: "label",
                    class: {
                      blue: props.value == "Placed",
                      green:
                        props.value == "Completed" ||
                        props.value == "Fulfilled",
                      red: props.value == "Cancelled"
                    },
                    staticStyle: {
                      display: "inline-block",
                      "margin-left": "10px",
                      "border-radius": "30px"
                    }
                  },
                  [_vm._v(_vm._s(props.value || "?"))]
                )
              ]
            }
          },
          {
            key: "col-item-user",
            fn: function(props) {
              return [
                _c(
                  "div",
                  {
                    staticClass: "label green round small",
                    staticStyle: {
                      "font-size": "11px",
                      padding: "6px 0px",
                      "margin-right": "5px"
                    }
                  },
                  [_vm._v(_vm._s(_vm.formatUserInitials(props.value)))]
                ),
                _vm._v(
                  "\n      " +
                    _vm._s(props.value.USER_FIRST_NAME) +
                    " " +
                    _vm._s(props.value.USER_LAST_NAME) +
                    "\n    "
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }